import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import uploadIcon from "../../assets/svg/upload-icon.svg";
import downloadIcon from "../../assets/svg/download-icon.svg";
import templateIcon from "../../assets/svg/template-icon.svg";
import {
  downloadExcelApi,
  uploadExcelApi,
  downloadTemplateExcelApi,
} from "../masters/master-api";
import { downloadBase64File } from "../report/report-api";

const CustomerButtons = ({
  activeTab,
  responseMsg,
  isTemplate,
  isUpload,
  isDownload,
}) => {
  const tabs = [
    {
      label: "Dock Master",
      template: "dock_master",
      upload_url: "master_import/dock_master",
      download_url: "master_report/dock_master",
      key: "dock",
    },
    {
      label: "Vehicle Type",
      template: "vehicle_type",
      upload_url: "master_import/vehicle_type",
      download_url: "master_report/vehicle_type",
      key: "vehicle",
    },
    {
      label: "Customer",
      template: "customer",
      upload_url: "master_import/customer",
      download_url: "master_report/customers",
      key: "customer",
    },
    {
      label: "Transporters",
      template: "transporter",
      upload_url: "master_import/transporter",
      download_url: "master_report/transporters",
      key: "transporter",
    },
    {
      label: "Vendors",
      template: "vendor",
      upload_url: "master_import/vendor",
      download_url: "master_report/vendors",
      key: "vendor",
    },
    {
      label: "Product Type",
      template: "product_type",
      upload_url: "master_import/product_type",
      download_url: "master_report/product_types",
      key: "product",
    },
    {
      label: "Auto Report Trigger",
      template: "",
      upload_url: "",
      download_url: "master_report/auto_mail_triggers",
      key: "autotrigger",
    },
    {
      label: "Alert Configurations",
      template: "",
      upload_url: "",
      download_url: "master_report/alert_config",
      key: "alertconfigurations",
    },
    {
      label: "Register Fields",
      template: "",
      upload_url: "",
      download_url: "master_report/register_fields",
      key: "registerfields",
    },
  ];
  const [isUploading, setIsUploading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isTemplateDownloading, setIsTemplateDownloading] = useState(false);

  const downloadExcel = async (responseMsg) => {
    const index = tabs.findIndex((item) => item.key === activeTab);
    if (index > -1) {
      setIsDownloading(true);
      try {
        const response = await downloadExcelApi(tabs[index].download_url);

        if (response && response.status === 200) {
          if (response.data?.success === true && response.data?.base64) {
            const base64String = response.data.base64;
            const fileName = response.data.file_name || `${activeTab}_report_${new Date().getTime()}.xlsx`;

            downloadBase64File(base64String, fileName);
            if (typeof responseMsg === "function") {
              responseMsg(response.data);
            }
          } else if (response.data instanceof Blob) {
            const blobUrl = URL.createObjectURL(response.data);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = `${activeTab}_report_${new Date().getTime()}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
            if (typeof responseMsg === "function") {
              responseMsg({ success: true, message: "Downloaded successfully" });
            }
          } else if (response.data?.base64) {
            const base64String = response.data.base64;
            const fileName = response.data.file_name || `${activeTab}_report_${new Date().getTime()}.xlsx`;
            downloadBase64File(base64String, fileName);
            if (typeof responseMsg === "function") {
              responseMsg(response.data);
            }
          } else if (response.data?.url) {
            window.open(response.data.url, "_blank");
            if (typeof responseMsg === "function") {
              responseMsg(response.data);
            }
          } else if (response.data) {
            if (typeof responseMsg === "function") {
              responseMsg(response.data);
            }
          }
        } else if (response?.data) {
          if (typeof responseMsg === "function") {
            responseMsg(response.data);
          }
        }
      } catch (error) {
        console.error("Error downloading Excel:", error);
        if (typeof responseMsg === "function" && error.response?.data) {
          responseMsg(error.response.data);
        }
      } finally {
        setIsDownloading(false);
      }
    }
  };
  const fileInputRef = useRef(null);
  const handleFileClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    } else {
      console.error("File input is not initialized.");
    }
  };
  const handleFileChange = (event, responseMsg) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result; // this will be the byte code (base64String)

        uploadExcel(base64String, responseMsg);
      };
      reader.readAsDataURL(file);
    } else {
      alert("Please select a valid excel file.");
    }
    fileInputRef.current.value = "";
  };
  const uploadExcel = async (base64String, responseMsg) => {
    const index = tabs.findIndex((item) => item.key === activeTab);
    if (index === -1) return;

    setIsUploading(true);
    try {
      const response = await uploadExcelApi(
        tabs[index].upload_url,
        base64String
      );

      if (response && response.data) {
        if (response.data.base64) {
          const fileName = response.data.file_name || `${activeTab}_${new Date().getTime()}.xlsx`;
          downloadBase64File(response.data.base64, fileName);
        }

        if (typeof responseMsg === "function") {
          responseMsg(response.data);
        }
      }
    } catch (error) {
      console.error("Error uploading Excel:", error);
      if (typeof responseMsg === "function" && error.response?.data) {
        responseMsg(error.response.data);
      }
    } finally {
      setIsUploading(false);
    }
  };

  const downloadTemplateExcel = async (responseMsg) => {
    const index = tabs.findIndex((item) => item.key === activeTab);
    if (index > -1) {
      setIsTemplateDownloading(true);
      try {
        const response = await downloadTemplateExcelApi(tabs[index].template);
        if (response && response.status === 200) {
          if (response.data?.success === true && response.data?.base64) {
            const base64String = response.data.base64;
            const fileName =
              response.data.file_name ||
              activeTab + "_template_" + new Date().getTime() + ".xlsx";

            downloadBase64File(base64String, fileName);
            if (typeof responseMsg === "function") {
              responseMsg(response.data);
            }
          } else if (response.data?.base64) {
            const fileName =
              activeTab + "_template_" + new Date().getTime() + ".xlsx";
            downloadBase64File(response.data.base64, fileName);
            if (typeof responseMsg === "function") {
              responseMsg(response.data);
            }
          } else if (response.data) {
            if (typeof responseMsg === "function") {
              responseMsg(response.data);
            }
          }
        } else if (response?.data) {
          if (typeof responseMsg === "function") {
            responseMsg(response.data);
          }
        }
      } catch (error) {
        console.error("Error downloading Template Excel:", error);
        if (typeof responseMsg === "function" && error.response?.data) {
          responseMsg(error.response.data);
        }
      } finally {
        setIsTemplateDownloading(false);
      }
    }
  };
  const currentTab = tabs.find((item) => item.key === activeTab);

  return (
    <div>
      {currentTab && (
        <div className="style-justify-start">
          {isUpload && currentTab.upload_url && (
            <>
              <button
                className="me-2"
                onClick={
                  !isUploading
                    ? () => {
                      handleFileClick();
                    }
                    : null
                }
                style={{
                  background: "none",
                  border: "0.6px solid #DCDFE4",
                  borderRadius: "12px",
                  padding: "10px 8px",
                  height: "36px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  opacity: isUploading ? 0.6 : 1,
                  cursor: isUploading ? "not-allowed" : "pointer",
                }}
                disabled={isUploading}
              >
                {isUploading ? (
                  <>
                    <div
                      className="spinner-border spinner-border-sm text-secondary"
                      role="status"
                      style={{ width: "14px", height: "14px" }}
                    ></div>
                    <span
                      className="ps-1"
                      style={{
                        fontSize: "13px",
                        fontWeight: "600",
                        color: "#172B4D",
                      }}
                    >
                      Uploading...
                    </span>
                  </>
                ) : (
                  <>
                    <img
                      src={uploadIcon}
                      alt="upload"
                      style={{ width: "14px", height: "14px" }}
                    />
                    <span
                      className="ps-1"
                      style={{
                        fontSize: "13px",
                        fontWeight: "600",
                        color: "#172B4D",
                      }}
                    >
                      Upload
                    </span>
                  </>
                )}
              </button>

              <input
                ref={fileInputRef}
                type="file"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                onChange={(event) => {
                  handleFileChange(event, responseMsg);
                }}
                style={{ display: "none" }}
              />
            </>
          )}
          {isDownload && currentTab.download_url && (
            <button
              onClick={
                !isDownloading
                  ? () => {
                    downloadExcel(responseMsg);
                  }
                  : null
              }
              className="me-2"
              style={{
                background: "none",
                border: "0.6px solid #DCDFE4",
                borderRadius: "12px",
                padding: "10px 8px",
                height: "36px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                opacity: isDownloading ? 0.6 : 1,
                cursor: isDownloading ? "not-allowed" : "pointer",
              }}
              disabled={isDownloading}
            >
              {isDownloading ? (
                <>
                  <div
                    className="spinner-border spinner-border-sm text-secondary"
                    role="status"
                    style={{ width: "14px", height: "14px" }}
                  ></div>
                  <span
                    className="ps-1"
                    style={{
                      fontSize: "13px",
                      fontWeight: "600",
                      color: "#172B4D",
                    }}
                  >
                    Downloading...
                  </span>
                </>
              ) : (
                <>
                  <img
                    src={downloadIcon}
                    alt="download"
                    style={{ width: "14px", height: "14px" }}
                  />
                  <span
                    className="ps-1"
                    style={{
                      fontSize: "13px",
                      fontWeight: "600",
                      color: "#172B4D",
                    }}
                  >
                    Download
                  </span>
                </>
              )}
            </button>
          )}
          {isTemplate && currentTab.template && (
            <button
              onClick={
                !isTemplateDownloading
                  ? () => {
                    downloadTemplateExcel(responseMsg);
                  }
                  : null
              }
              className="me-2"
              style={{
                background: "none",
                border: "0.6px solid #DCDFE4",
                borderRadius: "12px",
                padding: "10px 8px",
                height: "36px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                opacity: isTemplateDownloading ? 0.6 : 1,
                cursor: isTemplateDownloading ? "not-allowed" : "pointer",
              }}
              disabled={isTemplateDownloading}
            >
              {isTemplateDownloading ? (
                <>
                  <div
                    className="spinner-border spinner-border-sm text-secondary"
                    role="status"
                    style={{ width: "14px", height: "14px" }}
                  ></div>
                  <span
                    className="ps-1"
                    style={{
                      fontSize: "13px",
                      fontWeight: "600",
                      color: "#172B4D",
                    }}
                  >
                    Downloading...
                  </span>
                </>
              ) : (
                <>
                  <img
                    src={templateIcon}
                    alt="template"
                    style={{ width: "14px", height: "14px" }}
                  />
                  <span
                    className="ps-1"
                    style={{
                      fontSize: "13px",
                      fontWeight: "600",
                      color: "#172B4D",
                    }}
                  >
                    Template
                  </span>
                </>
              )}
            </button>
          )}
        </div>
      )}
      {/* {tabs.map(({ label, to, key }) => (
                <Link
                    key={key}
                    to={to}
                    className={`customer-tab ${activeTab === key ? "active" : ""}`}
                    onClick={() => setActiveTab(key)}
                >
                    {label}
                </Link>
            ))} */}
    </div>
  );
};

export default CustomerButtons;
